import { Col, Container, Nav, Row, TabContainerProps } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import { useLocation } from 'react-router-dom';

export type tabsProps = {
  name: string;
  content: React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  href?: string;
};

export type customTabsProps = TabContainerProps &
  React.PropsWithChildren<{
    tabs: tabsProps[];
    variant?: string;
    className?: string;
  }>;

const Tabs = ({ tabs, variant, className }: customTabsProps) => {
  const { pathname } = useLocation();

  const selectedTabIndex = tabs.findIndex((tab: tabsProps) => {
    if (tab.href && tab.href!.indexOf(pathname) > -1) {
      return true;
    }
    return false;
  });

  return (
    <Container className={`${className} p-0 custom-tabs-component`}>
      <Tab.Container
        id="menu-tabs"
        defaultActiveKey={
          selectedTabIndex < 0 ? '0' : selectedTabIndex.toString()
        }
        activeKey={
          selectedTabIndex < 0 ? undefined : selectedTabIndex.toString()
        }
      >
        <Row className="m-0">
          <Col className="p-0">
            <Nav className={`tab-nav flex-row ${variant}`}>
              {tabs.map((tab, i) => (
                <Nav.Item key={i}>
                  <Nav.Link eventKey={i} href={tab.href} className={'tab-link'}>
                    {tab.leftIcon && (
                      <span className="left-icon">{tab.leftIcon}</span>
                    )}
                    <span className={'tab-name'}>{tab.name}</span>
                    {tab.rightIcon && (
                      <span className="right-icon">{tab.rightIcon}</span>
                    )}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
        </Row>
        <Row className="m-0 pt-5">
          <Tab.Content className="p-0">
            {tabs.map((tab, i) => (
              <Tab.Pane key={i} eventKey={i}>
                {tab.content}
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default Tabs;
